import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Group, Modal, Stack } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormActions } from '../FormActions';
import { AddPersonFormSchemaType, useAddPersonForm } from './hooks';

export type AddPersonModalPropsType = {
  opened: boolean;
  onClose: () => void;
  onSubmit: (data: AddPersonFormSchemaType) => Promise<void>;
};

export const AddPersonModal: React.FC<AddPersonModalPropsType> = ({
  opened,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const form = useAddPersonForm();

  const handleClose = (): void => {
    form.reset();
    onClose();
  };

  const handleSubmit = async (data: AddPersonFormSchemaType): Promise<void> => {
    await onSubmit(data);
    handleClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={t('ADD_PERSON_MODAL.TITLE')}
      size="md"
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <Stack>
            <Group flex="1">
              <TextField
                fieldName="firstname"
                label={t('ADD_PERSON_MODAL.FIRSTNAME_LABEL')}
                placeholder={t('ADD_PERSON_MODAL.FIRSTNAME_PLACEHOLDER')}
                flex="1"
                required
              />
              <TextField
                fieldName="lastname"
                label={t('ADD_PERSON_MODAL.LASTNAME_LABEL')}
                placeholder={t('ADD_PERSON_MODAL.LASTNAME_PLACEHOLDER')}
                flex="1"
                required
              />
            </Group>
            <FormActions
              onCancel={handleClose}
              saveButtonText={t('SAVE_BUTTON')}
              cancelButtonText={t('CANCEL_BUTTON')}
            />
          </Stack>
        </form>
      </FormProvider>
    </Modal>
  );
};
